import styled from "styled-components";

export const Container = styled.div`
  @media (min-width: 1921px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 32px;
      text-align: center;
      width: 29px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 21px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;
      height: 32px;

      > button {
        background-color: #fff;
        height: 32px;
        color: #000;
        font-size: 6px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 50px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;

      .ant-input-number-input {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-weight: 800;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -3%;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 26px;
      text-align: center;
      width: 24px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 17px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;
      height: 26px;

      > button {
        background-color: #fff;
        height: 16px;
        padding: 4px 7px;
        color: #000;
        font-size: 6px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 40px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;
      height: 26px;

      .ant-input-number-input {
        font-weight: 800;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.03em;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
      }

      .ant-input-number-handler-wrap {
        display: none;
        opacity: 0;
        height: 26px;
        width: 40px;
      }

      .ant-input-number-input-wrap {
        input {
          height: 24px;
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 26px;
      text-align: center;
      width: 23px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 17px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;
      height: 23px;

      > button {
        background-color: #fff;
        height: 16px;
        padding: 4px 7px;
        color: #000;
        font-size: 6px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 40px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;
      height: 26px;

      .ant-input-number-input {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -3%;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
      }

      .ant-input-number-handler-wrap {
        display: none;
        opacity: 0;
        height: 26px;
        width: 40px;
      }

      .ant-input-number-input-wrap {
        input {
          height: 24px;
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 22px;
      text-align: center;
      width: 18px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 14px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;
      height: 22px;

      > button {
        background-color: #fff;
        height: 22px;
        color: #000;
        font-size: 8px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 40px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;
      height: 22px;

      .ant-input-number-input {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -3%;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
        height: 18px;
      }

      .ant-input-number-handler-wrap {
        display: none;
        opacity: 0;
        height: 22px;
        width: 40px;
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 35px;
      text-align: center;
      width: 29px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 21px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;

      > button {
        background-color: #fff;
        height: 22px;
        color: #000;
        font-size: 8px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 77px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;
      height: 35px;

      .ant-input-number-input {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-weight: 800;
        font-size: 26px;
        line-height: 100%;
        letter-spacing: -3%;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
        height: 33px;
      }

      .ant-input-number-handler-wrap {
        display: none;
        opacity: 0;
        width: 77px;
      }
    }
  }

  @media (max-width: 567px) {
    position: relative;
    display: flex;
    align-items: center;

    .btn-count {
      height: 24px;
      text-align: center;
      width: 18px;
      color: #a0a0a0;
      border: 1px solid #a0a0a0;
      font-size: 16px;
      cursor: pointer;
      place-content: center;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      font-weight: 700;
    }

    .btn-count.plus {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    .controls-input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      display: flex;
      flex-direction: column;

      > button {
        background-color: #fff;
        height: 24px;
        color: #000;
        font-size: 16px;
        border: 1px solid #d9d9d9;
        &:first-child {
          border-bottom: none;
        }
        &:disabled {
          color: rgba(0, 0, 0, 0.45);
          cursor: not-allowed;
        }
      }
    }

    .ant-input-number {
      border-radius: 0;
      border: none;
      box-shadow: none;
      width: 50px;
      border-top: 1px solid #a0a0a0;
      border-bottom: 1px solid #a0a0a0;
      height: 24px;

      .ant-input-number-input {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -3%;
        border-radius: 0;
        text-align: center;
        color: #653cd5;
        padding: unset;
        height: 22px;
      }

      .ant-input-number-handler-wrap {
        display: none;
        opacity: 0;
        width: 50px;
      }
    }
  }
`;
